import React from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import moment from 'moment';
import Modal from '../../../../../commonComponents/modal/Modal';
import CloseIcon from '../../../../../commonComponents/icons/icon/CloseIcon';
import translate from '../../../../../commonComponents/translate';
import ServerSideList from '../../../../../commonComponents/lists/ServerSideList';
import { newFormatPrice } from '../../../../../services/utilityFunctions';

function InvestmentDetailsModal(props) {
  const { t, onClose, filters } = props;
  const tableUrL = '/table/tailor-made/arcova/investments/list';
  const tableId = 'arcova_investment_list';

  const columns = [
    {
      field: 'amountInvested',
      textAlign: 'left',
      title: t('report.arcova.amountInvested'),
      width: 250,
      sortable: false,
      template: ({ amountInvested, currencyInfo }) =>
        renderToStaticMarkup(
          <div className="commissions">
            {newFormatPrice(amountInvested, true, currencyInfo.code) || ' - '}
          </div>,
        ),
    },
    {
      field: 'orderDate',
      textAlign: 'left',
      title: t('report.arcova.orderDate'),
      width: 100,
      sortable: false,
      template: ({ orderDate }) =>
        renderToStaticMarkup(<>{moment(orderDate).format('DD MMM YYYY')}</>),
    },
    {
      field: 'expirationDate',
      textAlign: 'left',
      title: t('report.arcova.expirationDate'),
      width: 150,
      sortable: false,
      template: ({ expirationDate }) =>
        renderToStaticMarkup(
          <>{moment(expirationDate).format('DD MMM YYYY')}</>,
        ),
    },
  ];

  const filtersNoDate = {
    ...filters,
    startDate: null,
    endDate: null,
  };

  return (
    <Modal onClose={onClose} id="arcovaInvestmentDetailsModal">
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <div className="modalTitle">
            <h5 className="title">
              {t('report.arcova.modalInvestmentDetails')}
            </h5>
            <button type="button" onClick={onClose} className="closeIcon">
              <CloseIcon width="20" height="20" color="#6F6C80" />
            </button>
          </div>
          <div
            id="modalBodyInvestmentDetails"
            className="modal-body"
            style={{ maxHeight: '70vh', overflowY: 'auto' }}
          >
            <ServerSideList
              dataSourceURL={tableUrL}
              columns={columns}
              query={filtersNoDate}
              id={tableId}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

InvestmentDetailsModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    user: PropTypes.string,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
  }).isRequired,
};
export default translate(InvestmentDetailsModal);
